import {
    LAYOUT_ENTRY_GUTTER_COMMENTS_SET,
    LAYOUT_ENTRY_GUTTER_METRICS_SET
} from '../_actions/types'

export type LayoutAction = {
    type: string;
    layout?: LayoutState;
};

export type LayoutState = {
    entryGutter: LayoutEntryGutterState
};

export type LayoutEntryGutterState = {
    comments: LayoutEntryGutterCommentsState;
    metrics: LayoutEntryGutterMetricsState;
};

export type LayoutEntryGutterCommentsState = {
    display: 'default' | 'minimized';
}

export type LayoutEntryGutterMetricsState = {
    display: 'default' | 'minimized';
    totalCycleTime: LayoutEntryGutterMetricsTotalCycleTimeState;
}

export type LayoutEntryGutterMetricsTotalCycleTimeState = {
    display: 'graph' | 'table';
    view: 'summary' | 'detail';
}

const initialState: LayoutState = {
    entryGutter: {
        comments: {
            display: 'default'
        },
        metrics: {
            display: 'default',
            totalCycleTime: {
                display: 'graph',
                view: 'summary'
            }
        }
    }
};

export const reducer = (state: LayoutState = initialState, action: LayoutAction): LayoutState => {
    switch (action.type) {
        case LAYOUT_ENTRY_GUTTER_COMMENTS_SET:
            return {
                ...state,
                entryGutter: {
                    ...state.entryGutter,
                    comments: {
                        ...state.entryGutter.comments,
                        ...action?.layout?.entryGutter?.comments
                    }
                }
            };
        case LAYOUT_ENTRY_GUTTER_METRICS_SET:
            return {
                ...state,
                entryGutter: {
                    ...state.entryGutter,
                    metrics: {
                        ...state.entryGutter.metrics,
                        ...action?.layout?.entryGutter?.metrics
                    }
                }
            };
        default:
            return state;
    }
};